<template>

  <div>

    <div v-if="errorsExist" class="alert alert-danger alert-dismissible em-12" role="alert" v-cloak>
      <div v-for="form_error in form_errors">
        {{ form_error }}
      </div>
    </div>

    <div v-if="form_status" v-cloak class="alert alert-success">
      {{ form_status}}
    </div>
    <div v-if="messagesExist" v-cloak class="alert alert-info">
      <div v-for="form_message in form_messages">
        {{ form_message }}
      </div>
    </div>
  </div>

</template>

<script>
  module.exports = {
    props: {
      form_errors: {
        Type: Array,
      },
      form_status: {default: ""},
      form_messages: {
        Type: Array,
      },

    },
    data: function () {
      return {}
    },

    methods: {},
    computed: {
      errorsExist: function () {
        if (this.form_errors && this.form_errors.length > 0) {
          return true;
        } else {
          return false;
        }
      },
      messagesExist: function () {
        if (this.form_messages && this.form_messages.length > 0) {
          return true;
        } else {
          return false;
        }
      },
    }

  }


</script>



// WEBPACK FOOTER //
// app-message-list.vue?61f04c14